import { useRef, useState } from "react";
import { motion } from "framer-motion";

export const MagneticButton = ({ children, onClick, href, variant = "primary", testId, className = "" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos({ x: (e.clientX - r.left - r.width / 2) * 0.28, y: (e.clientY - r.top - r.height / 2) * 0.34 });
  };

  const styles =
    variant === "primary"
      ? "bg-[#0A192F] text-white hover:bg-[#12294a] shadow-[0_10px_40px_rgba(10,25,47,0.35)]"
      : variant === "cyan"
      ? "bg-[#00E5FF] text-[#0A192F] hover:bg-[#4deeff] shadow-[0_10px_40px_rgba(0,229,255,0.4)]"
      : "border border-[#0A192F]/25 text-[#0A192F] hover:border-[#0A192F] bg-white/40 backdrop-blur";

  const inner = (
    <motion.span
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => setPos({ x: 0, y: 0 })}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 180, damping: 16, mass: 0.4 }}
      className={`group inline-flex cursor-pointer items-center gap-3 rounded-full px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.18em] transition-colors duration-300 ${styles} ${className}`}
    >
      {children}
    </motion.span>
  );

  if (href)
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className="inline-block">
        {inner}
      </a>
    );
  return (
    <button type="button" onClick={onClick} data-testid={testId} className="inline-block bg-transparent p-0">
      {inner}
    </button>
  );
};
